import { Fragment } from 'react';
import { cn } from '../../lib/utils';

interface SegmentedToggleProps<T extends string> {
  value: T;
  onChange: (value: T) => void;
  options: { value: T; label: string }[];
  label: string;
  fullWidth?: boolean;
}

/** Revenue History's segmented-control styling, for page-local view choices. */
export function SegmentedToggle<T extends string>({ value, onChange, options, label, fullWidth = false }: SegmentedToggleProps<T>) {
  return (
    <div role="group" aria-label={label} className="flex shrink-0 h-10 overflow-hidden bg-white dark:bg-background-dark border border-[#D0D5DD] dark:border-borderPrimary-dark rounded-lg">
      {options.map((option, index) => (
        <Fragment key={option.value}>
          {index > 0 && <div className="h-[38px] w-px bg-[#D0D5DD] dark:bg-borderPrimary-dark" />}
          <button
            type="button"
            aria-pressed={value === option.value}
            onClick={() => onChange(option.value)}
            className={cn('px-4 py-1.5 text-[14px] leading-5 font-semibold whitespace-nowrap transition-all', fullWidth && 'flex-1',
              value === option.value
                ? 'bg-[#EDFCF5] dark:bg-[#EDFCF5]/20 text-[#0E8965] dark:text-[#0E8965]'
                : 'text-[#344054] dark:text-textTertiary-dark hover:text-[#475467] dark:hover:text-textTertiary-dark')}
          >
            {option.label}
          </button>
        </Fragment>
      ))}
    </div>
  );
}
